<template>
	<div>
		<keep-alive>
			<router-view :key="$route.fullPath" />
		</keep-alive>
	</div>
</template>

<script>
	import {
		getclassifyType
	} from '../src/api/app.js'
	export default {
		data() {
			return {}
		},

		created() {},
		mounted() {
			this.getclassifyTypeFun()
			document.addEventListener('contextmenu', this.disableRightClick);
		},
		beforeDestroy() {
			document.removeEventListener('contextmenu', this.disableRightClick);
		},
		methods: {
			disableRightClick(event) {
				event.preventDefault();
			},
			getclassifyTypeFun() {
				//服务类型 1
				//材质 2
				//工艺 7
				//尺码 3
				//颜色 4
				//加工类型 5
				//品质 6
				//细分类 8
				//主营产品 9
				//品质定位 10
				//生产品类 11
				//服务类型 1


				this.http.get('/applet/classify/classifyInfo/list?classifyType=1', {}).then(res => {
					if (res) {
						localStorage.setItem('fwTypeList', JSON.stringify(res.data))
					}
				})

				//材质 2
				this.http.get('/applet/classify/classifyInfo/list?classifyType=2', {}).then(res => {
					if (res) {
						localStorage.setItem('czList', JSON.stringify(res.data))
					}
				})

				// 尺码 3
				this.http.get('/applet/classify/classifyInfo/list?classifyType=3', {}).then(res => {
					if (res) {
						localStorage.setItem('cmList', JSON.stringify(res.data))
					}
				})

				// 颜色 4
				this.http.get('/applet/classify/classifyInfo/list?classifyType=4', {}).then(res => {
					if (res) {
						localStorage.setItem('ysList', JSON.stringify(res.data))
					}
				})
				// 加工类型 5
				this.http.get('/applet/classify/classifyInfo/list?classifyType=5', {}).then(res => {
					if (res) {
						localStorage.setItem('jgTypeList', JSON.stringify(res.data))
					}
				})
				// 品质 6
				this.http.get('/applet/classify/classifyInfo/list?classifyType=6', {}).then(res => {
					if (res) {
						localStorage.setItem('pzList', JSON.stringify(res.data))
					}
				})
				// 工艺 7
				this.http.get('/applet/classify/classifyInfo/list?classifyType=7', {}).then(res => {
					if (res) {
						localStorage.setItem('gyList', JSON.stringify(res.data))
					}
				})
				// 细分类 8
				this.http.get('/applet/classify/classifyInfo/list?classifyType=8', {}).then(res => {
					if (res) {
						localStorage.setItem('xList', JSON.stringify(res.data))
					}
				})
				// 主营产品 9
				this.http.get('/applet/classify/classifyInfo/list?classifyType=9', {}).then(res => {
					if (res) {

						localStorage.setItem('zycpList', JSON.stringify(res.data))
					}
				})
				// 品质定位 10
				this.http.get('/applet/classify/classifyInfo/list?classifyType=10', {}).then(res => {
					if (res) {
						localStorage.setItem('pzdwList', JSON.stringify(res.data))
					}
				})
				this.http.get('/applet/classify/classifyInfo/list?classifyType=10', {}).then(res => {
					if (res) {
						localStorage.setItem('scplList', JSON.stringify(res.data))
					}
				})
			},
		}
	}
</script>
<style lang="scss">
	@import '@/assets/css/base.scss';


	* {
		padding: 0;
		margin: 0;
	}

	ul {
		list-style: none;
	}

	img {
		border-style: none;
	}

	body {
		margin: 0;
		background: #F5F5F5;
	}

	div {
		box-sizing: border-box;
	}

	.icon {
		min-width: 6px !important;
		min-height: 6px !important;
		width: 1em !important;
		height: 1em !important;
		vertical-align: -0.15em !important;
		fill: currentColor !important;
		// overflow: hidden !important;
	}

	// 输入框提示文本样式
	.el-input__inner::placeholder {
		color: $-color-AAA !important;
	}
</style>